import { Link } from "react-router-dom";
import "./subMenu.css";

const SubMenu = ({ linkList, menuTitle, menuClickImp, linkClickImp }) => {
  // Triggered on menu click
  const menuClick = (evt) => {
    const container = evt.target.closest(".sub-container");
    const menu = container.querySelector(".sub-menu");
    if (menuClickImp) {
      menuClickImp(container, ".sub-menu");
    }

    setTimeout(() => {
      if (menu.classList.contains("display-flex")) {
        container.querySelector("h4").classList.add("sub-title-expanded");
      } else {
        container.querySelector("h4").classList.remove("sub-title-expanded");
      }
    }, 350);
  };

  const linkClick = (evt) => {
    const container = evt.target.closest(".sub-menu");
    if (window.matchMedia("(min-width: px)")) {
      linkClickImp(evt);
      container.classList.add("display-none");
      container.classList.remove("display-flex");
    }
  };

  // Triggered on link click
  return (
    <div className="sub-container">
      <h4 onClick={(e) => menuClick(e)}>{menuTitle}</h4>
      <ul className="sub-menu display-none">
        {linkList.map((element, index) => (
          <li key={`${element}${index}`}>
            <Link to={`/${element.link}`} onClick={(e) => linkClick(e)}>
              {element.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubMenu;
